// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"_1sDDq","vertical":"_2Hdpf","bullet":"_277qd"};